import axiosClient from 'api/axiosClient';
import { useCallback } from 'react';

export default function useGetUnreadNotificationCount() {
  const getUnreadNotificationCount = useCallback(async (): Promise<number | undefined> => {
    try {
      const response = await axiosClient.get('/notification/unreadCount');
      return response?.data?.data?.unreadCount;
    } catch (error) {
      return undefined;
    }
  }, []);

  return { getUnreadNotificationCount };
}
